import React from 'react'
import assets from 'xui/assets'
import CommonLogo, { ICommonLogoOptionalProps } from './CommonLogo'

// const LOGO = require('../img/about/logo_lazada.png')
const LOGO = assets.images.logo.lazada

const LazadaLogo = (props: ICommonLogoOptionalProps) => <CommonLogo source={LOGO} {...props} />

export default LazadaLogo
